import { cn } from "@omni/utils/styles";

import { HIGHLIGHT_RESPONSE_REGEX } from "@/components/Search/SearchBar/config/searchBar.config";
import { HighlightMatch } from "@/components/Search/SearchBar/types/searchBar.types";

type HighlightProps = {
    highlightMatch: HighlightMatch;
    reverseHighlight?: boolean;
};

export const Highlight = ({
    highlightMatch,
    reverseHighlight = false
}: HighlightProps) => {
    const highlightedValue = highlightMatch.value.replace(
        HIGHLIGHT_RESPONSE_REGEX,
        `<mark class="${cn("tw:p-0 tw:bg-transparent", {
            "tw:font-bold": !reverseHighlight,
            "tw:font-normal": reverseHighlight
        })}">$1</mark>`
    );

    return (
        <div
            className={cn({
                "tw:font-bold": reverseHighlight
            })}
            dangerouslySetInnerHTML={{ __html: highlightedValue }}
        />
    );
};
